import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Shirditoshegaoncabs() {



    const cardData = {





keyword: "Shirdi to Shegaon Cab",
headingDescription: "Sai Shirdi Cab provides comfortable and reliable Shirdi to Shegaon cab service for devotees, families, senior citizens, couples, and small groups traveling for pilgrimage or personal visits. Shegaon is an important religious destination in Maharashtra, and a private cab offers a convenient way to travel directly from Shirdi without changing vehicles during the journey. Passengers can choose one way cab service, round-trip taxi booking, or a customized return plan according to their itinerary. Sai Shirdi Cab can arrange suitable vehicles based on passenger count and luggage requirements, with planned pickup from Shirdi and direct drop at the required location in Shegaon. The service is also useful for travelers planning a longer Maharashtra pilgrimage covering multiple destinations along with Shirdi and Shegaon. With flexible travel arrangements, experienced drivers, and private transportation, Sai Shirdi Cab makes the Shirdi to Shegaon journey easier to organize for both individual travelers and families.",

topPlaces: [
{
title: "Shegaon",
description: "Shegaon is the primary destination for this route and is well known for the Gajanan Maharaj pilgrimage. Travelers can book a private Shirdi to Shegaon cab through Sai Shirdi Cab for one way or round-trip travel. The journey can be planned according to darshan requirements, passenger count, luggage, and preferred pickup and drop timings."
},
{
title: "Aurangabad",
description: "Aurangabad, officially known as Chhatrapati Sambhajinagar, is a useful heritage destination to include in a broader Maharashtra journey from Shirdi. Sai Shirdi Cab can arrange private transportation for travelers who want to combine pilgrimage with historical sightseeing. The itinerary can be customized around Shegaon, Shirdi, and nearby heritage attractions according to the available travel time."
},
{
title: "Ajanta-Ellora Caves",
description: "Ajanta-Ellora Caves are a valuable addition to a pilgrimage and heritage tour covering Shirdi and Shegaon. Families, couples, and small groups can use Sai Shirdi Cab for private transportation between these destinations. A customized itinerary allows travelers to plan sightseeing stops and continue their pilgrimage journey without depending on separate local transportation."
},
{
title: "Nashik",
description: "Nashik can be included in an extended pilgrimage itinerary connecting Shirdi with other important religious destinations in Maharashtra. Sai Shirdi Cab can arrange a private cab for travelers who want to cover Nashik along with their Shirdi and Shegaon journey. The route can be planned as a one-way, round-trip, or multi-destination travel package."
},
{
title: "Shani Shingnapur",
description: "Shani Shingnapur is a suitable religious destination for passengers planning a wider pilgrimage tour from Shirdi to Shegaon. Sai Shirdi Cab can arrange private cab transportation so families and devotees can visit multiple spiritual locations within one organized itinerary. Pickup, temple visits, sightseeing stops, and return travel can be coordinated according to the group's schedule."
},
{
title: "Trimbakeshwar",
description: "Trimbakeshwar is another important pilgrimage destination that can be added to a Maharashtra religious tour beginning in Shirdi. Travelers can book a private cab with Sai Shirdi Cab to combine Trimbakeshwar, Shirdi, and Shegaon within a customized route. This option is suitable for devotees and families who want flexible travel timings and convenient transportation between destinations."
},
{
title: "Bhimashankar",
description: "Bhimashankar can be included in an extended pilgrimage itinerary for travelers visiting several religious destinations across Maharashtra. Sai Shirdi Cab offers private cab arrangements that allow families and devotees to customize their route from Shirdi toward Shegaon while including additional stops. The trip can be organized for one-way travel, round trips, or multi-day pilgrimage programs."
},
{
title: "Pune",
description: "Pune can be added to a longer Maharashtra travel itinerary for passengers combining pilgrimage, family visits, business travel, or sightseeing with their Shirdi and Shegaon journey. Sai Shirdi Cab can arrange private outstation transportation with flexible routing and planned stops. Travelers can choose an itinerary that connects multiple destinations according to their complete travel schedule."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar provides a leisure option for travelers extending their Shirdi and Shegaon pilgrimage into a broader Maharashtra holiday. Families and small groups can book private cab transportation through Sai Shirdi Cab for flexible multi-day travel. The itinerary can include sightseeing, overnight stays, and transfers between destinations based on the preferred travel plan."
},
{
title: "Pandharpur",
description: "Pandharpur is an important pilgrimage destination that can be considered for a longer religious tour involving Shirdi and Shegaon. Sai Shirdi Cab can arrange private outstation transportation for devotees and families who want to cover multiple spiritual destinations in one journey. The route can be customized with suitable stops, temple visits, and return arrangements according to the group's requirements."
}
]
,








"services": [
{
"name": "Shirdi to Shegaon Cab",
"description": "Sai Shirdi Cabs provides comfortable Shirdi to Shegaon cab services for devotees, families, and travelers planning a convenient journey between these important religious destinations. Enjoy a direct and comfortable ride with suitable vehicle options for your travel needs."
},
{
"name": "Shirdi to Shegaon Taxi",
"description": "Book a reliable Shirdi to Shegaon taxi with Sai Shirdi Cabs for a convenient intercity and pilgrimage journey. Our taxi options are suitable for individuals, families, and groups looking for a comfortable ride from Shirdi to Shegaon."
},
{
"name": "Shirdi to Shegaon cab service",
"description": "Our Shirdi to Shegaon cab service offers convenient transportation for travelers visiting Shegaon from Shirdi. Sai Shirdi Cabs helps passengers plan their journey with comfortable vehicles and flexible travel arrangements."
},
{
"name": "Shirdi to Shegaon taxi service",
"description": "Sai Shirdi Cabs offers a dependable Shirdi to Shegaon taxi service for devotees and tourists who prefer direct transportation. Travel comfortably between the two destinations while avoiding the inconvenience of changing multiple local transport options."
},
{
"name": "Shirdi to Shegaon cab booking",
"description": "Make your pilgrimage journey easier with Shirdi to Shegaon cab booking from Sai Shirdi Cabs. Reserve a suitable vehicle in advance and enjoy a convenient ride from Shirdi to Shegaon according to your planned travel schedule."
},
{
"name": "Shirdi to Shegaon taxi booking",
"description": "Shirdi to Shegaon taxi booking is a convenient option for passengers who want a dedicated vehicle for their journey. Sai Shirdi Cabs provides comfortable taxi choices for families, devotees, and groups traveling between Shirdi and Shegaon."
},
{
"name": "Shirdi to Shegaon taxi fare",
"description": "Get convenient Shirdi to Shegaon taxi fare options with Sai Shirdi Cabs based on the selected vehicle and travel requirements. Our taxi service is designed to provide comfortable outstation transportation for individuals and groups visiting Shegaon."
},
{
"name": "Shirdi to Shegaon cab fare",
"description": "Sai Shirdi Cabs provides practical Shirdi to Shegaon cab fare options for travelers planning their pilgrimage or family journey. Passengers can choose a suitable cab according to their group size and preferred travel requirements."
},
{
"name": "Shirdi to Shegaon one way cab",
"description": "Book a Shirdi to Shegaon one way cab when you need direct transportation without arranging a return journey. Sai Shirdi Cabs offers comfortable one way travel for devotees and passengers who are continuing their trip from Shegaon."
},
{
"name": "Shirdi to Shegaon one way taxi",
"description": "Sai Shirdi Cabs provides Shirdi to Shegaon one way taxi services for passengers looking for convenient point-to-point travel. This option is ideal for travelers who want a dedicated taxi from Shirdi to Shegaon without booking a round trip."
},
{
"name": "Shirdi to Shegaon round trip cab",
"description": "Plan a convenient pilgrimage with a Shirdi to Shegaon round trip cab from Sai Shirdi Cabs. A round trip option allows travelers to visit Shegaon and return to Shirdi with the convenience of having planned transportation for both directions."
},
{
"name": "Shirdi to Shegaon Ertiga Cab",
"description": "The Shirdi to Shegaon Ertiga Cab is a suitable choice for families and small groups looking for additional space during their pilgrimage journey. Sai Shirdi Cabs offers comfortable Ertiga vehicles for direct travel between Shirdi and Shegaon."
},
{
"name": "Shirdi to Shegaon Innova Cab",
"description": "Travel from Shirdi to Shegaon in a spacious Innova cab suitable for families and groups. Sai Shirdi Cabs provides Innova options for passengers who prefer a comfortable and relaxed journey while traveling for darshan or other personal purposes."
},
{
"name": "Shirdi to Shegaon Innova Crysta Cab",
"description": "For travelers seeking a premium and spacious ride, the Shirdi to Shegaon Innova Crysta Cab is an excellent option. Sai Shirdi Cabs offers Innova Crysta vehicles for families and groups who want enhanced comfort throughout their outstation journey."
},
{
"name": "Shirdi to Shegaon Sedan Cab",
"description": "Sai Shirdi Cabs offers Shirdi to Shegaon Sedan Cab services for individuals and small families looking for a comfortable and economical travel option. Sedan cabs are suitable for direct pilgrimage travel and planned intercity journeys."
},
{
"name": "Shirdi to Shegaon Gajanan Maharaj Temple Taxi",
"description": "Book a Shirdi to Shegaon Gajanan Maharaj Temple Taxi for a convenient pilgrimage journey to the famous temple in Shegaon. Sai Shirdi Cabs provides dedicated taxi options for devotees traveling from Shirdi for darshan and religious visits."
},
{
"name": "Shirdi to Shegaon Darshan Cab",
"description": "Sai Shirdi Cabs provides Shirdi to Shegaon Darshan Cab services for devotees planning a comfortable temple visit. With a dedicated cab, passengers can travel conveniently from Shirdi to Shegaon and organize their darshan journey according to their preferred schedule."
},
{
"name": "Shegaon to Shirdi Taxi",
"description": "Travel conveniently from Shegaon to Shirdi with a dedicated taxi from Sai Shirdi Cabs. This service is useful for devotees and families returning to Shirdi after visiting Gajanan Maharaj Temple or continuing their pilgrimage journey."
},
{
"name": "Shegaon to Shirdi Cab",
"description": "Book a comfortable Shegaon to Shirdi cab for direct and hassle-free transportation between the two pilgrimage destinations. Sai Shirdi Cabs offers suitable vehicles for individuals, families, and groups returning to Shirdi."
},
{
"name": "Shirdi Shegaon tour package",
"description": "Explore both important pilgrimage destinations with a convenient Shirdi Shegaon tour package from Sai Shirdi Cabs. Our cab options make it easier for devotees and families to plan comfortable travel between Shirdi and Shegaon with one way or round trip arrangements."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs offers reliable Shirdi to Shegaon and Shegaon to Shirdi cab services for devotees, families, and groups. From one way and round trip journeys to Ertiga, Innova, Innova Crysta, and Sedan options, travelers can choose transportation according to their comfort and trip requirements."
}
],
"tableData": [
["Shirdi to Shegaon Cab", "Shirdi to Shegaon Taxi"],
["Shirdi to Shegaon cab service", "Shirdi to Shegaon taxi service"],
["Shirdi to Shegaon cab booking", "Shirdi to Shegaon taxi booking"],
["Shirdi to Shegaon taxi fare", "Shirdi to Shegaon cab fare"],
["Shirdi to Shegaon one way cab", "Shirdi to Shegaon one way taxi"],
["Shirdi to Shegaon round trip cab", "Shirdi to Shegaon Ertiga Cab"],
["Shirdi to Shegaon Innova Cab", "Shirdi to Shegaon Innova Crysta Cab"],
["Shirdi to Shegaon Sedan Cab", "Shirdi to Shegaon Gajanan Maharaj Temple Taxi"],
["Shirdi to Shegaon Darshan Cab", "Shegaon to Shirdi Taxi"],
["Shegaon to Shirdi Cab", "Shirdi Shegaon tour package"],
["Sai Shirdi Cabs", "Shirdi to Shegaon Cab"]
]
,





whychoose: [  
 
    {   
 
        WhyChooseheading: "Shirdi to Shegaon Cab for Convenient Outstation Travel",   
 
        WhyChoosedescription: "Sai Shirdi Cabs provides Shirdi to Shegaon Cab services for devotees, families, tourists, senior citizens, and travellers planning an intercity journey between these important pilgrimage destinations. A private cab can be arranged according to your pickup location in Shirdi, travel date, preferred departure time, passenger count, luggage requirements, and overall travel schedule."   
 
    },   
 
    {   
 
        WhyChooseheading: "Private Taxi from Shirdi to Shegaon",   
 
        WhyChoosedescription: "Travellers can choose a private taxi from Shirdi to Shegaon for direct transportation between the two destinations. Sai Shirdi Cabs can coordinate the journey according to your selected pickup point, destination, preferred departure time, number of passengers, and luggage details, making it suitable for devotees and families planning a comfortable outstation trip."   
 
    },   
 
    {   
 
        WhyChooseheading: "Shirdi to Shegaon Cab for Pilgrimage Tours",   
 
        WhyChoosedescription: "Devotees visiting multiple religious destinations can arrange a cab from Shirdi to Shegaon as part of their pilgrimage itinerary. The journey can be planned after Sai Baba Darshan in Shirdi, allowing travellers to continue towards Shegaon according to their preferred schedule, accommodation plans, passenger requirements, and onward travel arrangements."   
 
    },   
 
    {   
 
        WhyChooseheading: "One Way Cab from Shirdi to Shegaon",   
 
        WhyChoosedescription: "Passengers who need transportation only from Shirdi to Shegaon can arrange a one-way cab service with Sai Shirdi Cabs. The booking can be planned around your travel date, pickup location, preferred departure time, passenger count, luggage, and destination requirements for a straightforward intercity transfer."   
 
    },   
 
    {   
 
        WhyChooseheading: "Shirdi to Shegaon Taxi for Families and Groups",   
 
        WhyChoosedescription: "Families and small groups travelling from Shirdi to Shegaon can arrange a private taxi according to their group size and luggage requirements. Travelling together in a dedicated cab can make it easier to coordinate the departure from Shirdi and continue the pilgrimage journey towards Shegaon without arranging separate transportation."   
 
    },   
 
    {   
 
        WhyChooseheading: "Hotel Pickup for Shirdi to Shegaon Cab",   
 
        WhyChoosedescription: "Travellers staying at hotels or accommodations in Shirdi can discuss pickup from their selected location while booking a cab to Shegaon. Providing the hotel location, travel date, preferred departure time, passenger count, and luggage details helps in planning the pickup and intercity transportation according to the group's itinerary."   
 
    },   
 
    {   
 
        WhyChooseheading: "Cab Service for Shirdi and Shegaon Temple Visits",   
 
        WhyChoosedescription: "Passengers planning visits to both Shirdi and Shegaon can use private cab transportation to connect the two pilgrimage destinations. Sai Shirdi Cabs can arrange the journey according to your religious travel plan, sightseeing requirements, preferred timings, passenger details, and selected pickup and drop-off locations."   
 
    },   
 
    {   
 
        WhyChooseheading: "Book Shirdi to Shegaon Cab with Sai Shirdi Cabs",   
 
        WhyChoosedescription: "To book a Shirdi to Shegaon Cab, contact Sai Shirdi Cabs with your pickup location, travel date, preferred departure time, passenger count, luggage information, and destination details. Complete journey information helps in arranging suitable private transportation according to your pilgrimage or outstation travel plans."   
 
    }   
 
]   
 
 
}; 
 
const faqData = [ 
 
{ 
 
question: "Can I book a cab from Shirdi to Shegaon?", 
 
answer: "Yes, Sai Shirdi Cabs provides private cab services from Shirdi to Shegaon for devotees, families, tourists, senior citizens, and travellers planning an intercity journey." 
 
}, 
 
{ 
 
question: "Is a one-way cab available from Shirdi to Shegaon?", 
 
answer: "Yes, one-way cab service can be arranged from Shirdi to Shegaon according to your travel date, pickup location, preferred departure time, passenger count, and destination requirements." 
 
}, 
 
{ 
 
question: "Can I travel from Shirdi to Shegaon after Sai Baba Darshan?", 
 
answer: "Yes, devotees can arrange a private cab from their hotel or another suitable pickup location in Shirdi to Shegaon after completing Sai Baba Darshan and their planned pilgrimage activities." 
 
}, 
 
{ 
 
question: "Can families book a Shirdi to Shegaon Taxi?", 
 
answer: "Yes, families can book a private taxi from Shirdi to Shegaon and provide their passenger count, luggage details, pickup location, and preferred travel schedule during the booking process." 
 
}, 
 
{ 
 
question: "Can senior citizens travel by cab from Shirdi to Shegaon?", 
 
answer: "Yes, senior citizens and their families can arrange private cab transportation from Shirdi to Shegaon according to their preferred departure time, pickup location, passenger requirements, and travel plans." 
 
}, 
 
{ 
 
question: "Can I get hotel pickup in Shirdi for the Shegaon journey?", 
 
answer: "Yes, pickup from your hotel, accommodation, or another suitable location in Shirdi can be discussed while booking the cab based on your travel details and service arrangement." 
 
}, 
 
{ 
 
question: "Can I travel with luggage in a Shirdi to Shegaon Cab?", 
 
answer: "Yes, passengers can travel with luggage, and it is recommended to provide luggage information along with the passenger count so the vehicle arrangement can be planned according to your requirements." 
 
}, 
 
{ 
 
question: "Can I book a Shirdi to Shegaon Cab for a pilgrimage tour?", 
 
answer: "Yes, devotees planning a pilgrimage covering Shirdi and Shegaon can arrange private cab transportation according to their temple visit schedule, travel date, passenger count, and preferred itinerary." 
 
}, 
 
{ 
 
question: "Can I choose my departure time from Shirdi to Shegaon?", 
 
answer: "Yes, you can provide your preferred departure time along with your travel date, pickup location, passenger details, luggage requirements, and destination while booking the cab." 
 
}, 
 
{ 
 
question: "How can I book a Shirdi to Shegaon Cab?", 
 
answer: "You can contact Sai Shirdi Cabs with your Shirdi pickup location, Shegaon destination, travel date, preferred departure time, passenger count, luggage information, and other travel requirements to arrange your cab booking." 
 
} 
 
]; 
 
const testimonials = [ 
 
{ 
 
id: 1, 
 
name: "Mr. Vishal Pawar", 
 
feedback: "Our pilgrimage included both Shirdi and Shegaon, so we needed direct transportation between the two places. Sai Shirdi Cabs arranged a private taxi that made the journey convenient for our family and gave us enough space for our travel luggage.", 
 
rating: 5 
 
}, 
 
{ 
 
id: 2, 
 
name: "Mrs. Meena Deshmukh", 
 
feedback: "After finishing our visit in Shirdi, we continued towards Shegaon by cab. The pickup coordination was simple, and travelling together in a private vehicle made the onward pilgrimage journey comfortable for our group.", 
 
rating: 5 
 
} 
 
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Shirdi to Shegaon Cab",
  "image": "https://www.saishirdicabs.com/assets/images/shirdi-to-shegaon-cab.webp",
  "description":
    "Book a Shirdi to Shegaon Cab with Sai Shirdi Cabs for a comfortable, convenient, and reliable journey from Shirdi to Shegaon. Our cab service is suitable for pilgrimage travel, family trips, religious visits, one-way journeys, round trips, and outstation travel. Get well-maintained cars, professional drivers, affordable fares, flexible pickup and drop locations, and easy booking assistance.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/shirdi-to-shegaon-cab"
  }
};




    return (
        <div>
<Helmet>
  <title>Shirdi to Shegaon Cab | Shirdi to Shegaon Taxi | +91 7776814559</title>

  <meta
    name="description"
    content="Book a Shirdi to Shegaon Cab with Sai Shirdi Cabs for a comfortable and reliable journey. Get professional drivers, well-maintained cars, affordable fares and easy booking for pilgrimage travel, one-way and round trips."
  />

  <meta
    name="keywords"
    content="Shirdi to Shegaon Cab, Shirdi to Shegaon Taxi, Shirdi to Shegaon cab service, Shirdi to Shegaon taxi service, Shirdi to Shegaon cab booking, Shirdi to Shegaon taxi booking, Shirdi to Shegaon one way cab, Shirdi to Shegaon round trip cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/107.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Shirditoshegaoncabs;